var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "selected-filters clearfix" }, [
    _c("hr", { staticClass: "d-lg-none" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "selected-filters__wrapper" },
      _vm._l(_vm.tagList, function(tag) {
        return tag.id < 22 || tag.id > 90 || tag.id === "price"
          ? _c(
              "span",
              {
                class: "selected-filter filter-" + tag.id,
                on: {
                  click: function($event) {
                    return _vm.removeTag(tag)
                  }
                }
              },
              [
                _c("span", [_vm._v(_vm._s(tag.name))]),
                _vm._v(" "),
                _c("svg", { attrs: { height: "9", width: "9" } }, [
                  _c("use", {
                    attrs: {
                      "xlink:href": "#svg_close",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink"
                    }
                  })
                ])
              ]
            )
          : _vm._e()
      }),
      0
    ),
    _vm._v(" "),
    _vm.tagList.length >= 2 ||
    (_vm.tagList.length === 1 && _vm.tagList[0].id === "price")
      ? _c(
          "span",
          {
            staticClass: "selected-filter reset-all",
            on: {
              click: function($event) {
                return _vm.resetAllTags()
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$translate("Ceres::Template.itemFilterReset")) +
                "\n    "
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }